import React from "react";
import semanticVariables from "ui-v2/styles/semantic_colors.module.scss";

export default ({ width = 24, height = 24, color = "primary" }) => {
  const colorValue = semanticVariables?.[`semantic_icon_${color}`];
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 24 24"
    >
      <g fill={colorValue} fillRule="evenodd" clipRule="evenodd">
        <path d="M14.945 1.25h1.11c1.368 0 2.47 0 3.337.117.9.12 1.658.38 2.26.981.602.602.86 1.36.982 2.26.116.867.116 1.97.116 3.337v8.11c0 1.367 0 2.47-.116 3.337-.121.9-.38 1.658-.982 2.26-.602.602-1.36.86-2.26.982-.867.116-1.97.116-3.337.116h-1.11c-1.367 0-2.47 0-3.337-.116-.9-.122-1.658-.38-2.26-.982-.524-.525-.79-1.17-.929-1.928-.135-.737-.161-1.638-.167-2.72a.75.75 0 011.5-.008c.006 1.093.034 1.868.142 2.457.105.567.272.895.515 1.138.277.277.666.457 1.4.556.755.101 1.756.103 3.191.103h1c1.436 0 2.437-.002 3.192-.103.734-.099 1.122-.28 1.4-.556.276-.277.456-.665.555-1.4.102-.755.103-1.756.103-3.191V8c0-1.435-.001-2.437-.103-3.192-.099-.734-.279-1.122-.556-1.399-.277-.277-.665-.457-1.399-.556-.755-.101-1.756-.103-3.192-.103h-1c-1.435 0-2.436.002-3.192.103-.733.099-1.122.28-1.399.556-.243.243-.41.572-.515 1.138-.108.589-.136 1.364-.142 2.457a.75.75 0 11-1.5-.008c.006-1.082.032-1.983.167-2.72.14-.758.405-1.403.93-1.928.601-.602 1.36-.86 2.26-.981.866-.117 1.969-.117 3.336-.117z"></path>
        <path d="M15.75 12a.75.75 0 00-.75-.75H4.027l1.961-1.68a.75.75 0 10-.976-1.14l-3.5 3a.75.75 0 000 1.14l3.5 3a.75.75 0 10.976-1.14l-1.96-1.68H15a.75.75 0 00.75-.75z"></path>
      </g>
    </svg>
  );
};
